/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_SubtitleInputs */

const tr_servis_subtitle = /** @type {(inputs: Servis_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ aboneliğinin operasyonel hükümleri: faturalandırma, SLA, askıya alma, veri ihracı, alt yüklenici bilgilendirmesi ve güvenlik ihbarı.`)
};

const en_servis_subtitle = /** @type {(inputs: Servis_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operational provisions of the ShopPanel™ subscription: billing, SLA, suspension, data export, sub-processor notification and security incident reporting.`)
};

const de_servis_subtitle = /** @type {(inputs: Servis_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Operative Bestimmungen des ShopPanel™ Abonnements: Rechnungsstellung, SLA, Sperrung, Datenexport, Information über Unterauftragsverarbeiter und Meldung von Sicherheitsvorfällen.`)
};

const ru_servis_subtitle = /** @type {(inputs: Servis_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Операционные положения подписки ShopPanel™: выставление счетов, SLA, приостановка, экспорт данных, уведомление о субподрядчиках и сообщение об инцидентах безопасности.`)
};

/**
* | output |
* | --- |
* | "Operational provisions of the ShopPanel™ subscription: billing, SLA, suspension, data export, sub-processor notification and security incident reporting." |
*
* @param {Servis_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_subtitle = /** @type {((inputs?: Servis_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_subtitle(inputs)
	if (locale === "de") return de_servis_subtitle(inputs)
	if (locale === "ru") return ru_servis_subtitle(inputs)
	return tr_servis_subtitle(inputs)
});